export default "__VITE_ASSET__CoxeummP__"